// store.js
import { createStore } from 'vuex';

export default createStore({
    state: {
      isMenuOpen: true,
      cadastro_parte_visivel: false,
      cadastro_parte_dados: {},
      processo: {},

      //advogados_colaboradores: [],
      //advogados_reus: [],
      // Outras variáveis globais podem ser adicionadas aqui
    },
    mutations: {
        toggleMenu(state) {
            state.isMenuOpen = !state.isMenuOpen;
        },

        toggleCadastroParteVisivel(state, cadastro_parte_dados) {
            state.cadastro_parte_visivel = !state.cadastro_parte_visivel;
            state.cadastro_parte_dados = cadastro_parte_dados;
        },

        setProcesso (state, processo) {
            state.processo = processo
        },

        setProcessoAssuntos(state, assuntos) {
            if (state.processo) { // Certifique-se de que o processo existe
                state.processo.assuntos = assuntos; // Atualize os assuntos do processo
            }
        },

        setProcessoPoloAtivo(state, novaParte) {
            if (!state.processo.polo_ativo) { // Certifica de que processo.polo_ativo é um array
                state.processo.polo_ativo = [];
            }

            if (novaParte.principal === undefined || novaParte.principal === null) {
                novaParte.principal = 1;
            }
            state.processo.polo_ativo.push(novaParte);
        },

        setProcessoPoloPassivo(state, novaParte) {
            if (!state.processo.polo_passivo) { // Certifica de que processo.polo_passivo é um array
                state.processo.polo_passivo = [];
            }

            if (novaParte.principal === undefined || novaParte.principal === null) {
                novaParte.principal = 1;
            }
            state.processo.polo_passivo.push(novaParte);
        },

        removePartePolo(state, parteId) {
            // Verifica se polo_ativo existe antes de tentar filtrar
            if (state.processo.polo_ativo && Array.isArray(state.processo.polo_ativo)) {
                state.processo.polo_ativo = state.processo.polo_ativo.filter(parte => parte.id !== parteId);
            }

            if (state.processo.polo_passivo && Array.isArray(state.processo.polo_passivo)) {
                state.processo.polo_passivo = state.processo.polo_passivo.filter(parte => parte.id !== parteId);
            }
        },
        
        setProcessoInformacoesAdicionais(state, informacoesAdicionais) {
            if (state.processo) { // Certifique-se de que o processo existe
                state.processo.informacoes_adicionais = informacoesAdicionais; // Atualize as informações adicionais do processo
            }
        },

        setProcessoTemInteresseConciliar(state, temInteresseConciliar) {
            if (state.processo) { // Certifique-se de que o objeto processo existe
                state.processo.tem_interesse_conciliar = temInteresseConciliar;
            }
        },
        setProcessoCompetencia(state, competencia_id) {
            if (state.processo) { // Certifique-se de que o objeto processo existe
                state.processo.competencia_id = competencia_id;
            }
        },

        // Adiciona ou atualiza uma petição no processo
        setPeticao(state, peticao) {
            // Verifica se tem processo e se já existe petição
            if (state.processo) { 
                if (!state.processo.peticoes) {
                    state.processo.peticoes = [];
                }
                state.processo.peticoes.push(peticao);
            }
        },

        addDocumentoToPeticao(state, { peticaoIndex, documento }) {
            if (state.processo.peticoes[peticaoIndex]) {
                state.processo.peticoes[peticaoIndex].documentos = state.processo.peticoes[peticaoIndex].documentos || [];
                state.processo.peticoes[peticaoIndex].documentos.push(documento);
            }
        },
        atualizarDocumentos(state, documentos) {
            state.processo.peticoes[0].documentos = documentos;
        },


        setDocumentPathTemporario(state, path) {
            state.documentPathTemporario = path;
        },
        clearDocumentPathTemporario(state) {
            state.documentPathTemporario = '';
        },

        atualizarAdvogados(state, { advogados, tipoAdv }) {
            if(tipoAdv == 'colaboradores'){
                state.processo.advogados_colaboradores = advogados;
            }
            else{
                state.processo.advogados_reus = advogados;
            }
        },


    },

    
});
